"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushEvent = pushEvent;
exports.initObservability = initObservability;
const faro_react_1 = require("@grafana/faro-react");
const faro_web_tracing_1 = require("@grafana/faro-web-tracing");
const is_bot_client_1 = require("./is-bot-client");
let faro;
function pushEvent(name, attributes) {
    faro?.api.pushEvent(name, attributes);
}
function initObservability(config) {
    if (faro) {
        return;
    }
    const samplingRate = (0, is_bot_client_1.isBotClient)({ userAgent: navigator.userAgent })
        ? 0
        : config.sessionTracking.samplingRate;
    faro = (0, faro_react_1.initializeFaro)({
        ...config,
        instrumentations: [...(0, faro_react_1.getWebInstrumentations)(), new faro_web_tracing_1.TracingInstrumentation()],
        sessionTracking: {
            ...config.sessionTracking,
            samplingRate,
        },
    });
}
